"use strict";
import { module } from "./app";
import * as _ from "lodash";
let jsonConfigFile = require('../../package.json');

module
  .constant("apiUrl", "https://techpad-admin.magview.com/api/")
  .constant("magViewApi", "/magview.api")
  .constant("globalHttpTimeout", 200000)
  .constant("appVersionNumber", "8.8.47.0.8740")
  .constant("fullAppVersion", "8.8.47.0.8740")
  // .constant("fullAppVersion", "8.8.47.0.8740" + `(${jsonConfigFile.techpadRCVersion})`)
  .value("tpConfig", {
    events: {
      portalNetworkAvailabilityChanged: "portalConnectionAvailable-change",
      givingUpReconnecting: 'networkReconnectingGiveUp'
    }
  })
  .value(
    "techpadInitialConfigProvider",
    window.techpadInitialConfigProvider ||
      (window.techpadInitialConfigProvider = {
        getMagviewUrl: function() {
          return null;
        },
        allowAnonymous: function() {
          return false;
        }
      })
  )
  .config([
    "$locationProvider",
    function($locationProvider) {
      $locationProvider.hashPrefix("");
    }
  ])
  .run([
    "$timeout",
    "authService",
    "$rootScope",
    "$location",
    "$animate",
    "$state",
    "eventsMgr",
    "serverTimeService",
    "errorSyncService",
    "rippleConfig",
    function(
      $timeout,
      authService,
      $rootScope,
      $location,
      $animate,
      $state,
      eventsMgr,
      serverTimeService,
      errorSyncService,
      rippleConfig
    ) {
      rippleConfig.rippleOpacity = 0.5;
      rippleConfig.rippleDelay = 20;
      rippleConfig.mobileTouch = false;

      $rootScope.authService = authService;

      authService.checkPortalUrl();

      errorSyncService.startSync();
      if (authService.loggedIn) {
        serverTimeService.updateServerTime();
      }

      ionic.Platform.ready(function() {
        // hide the status bar using the StatusBar plugin
        try {
          StatusBar.hide();
        } catch (ex) {

        }

        $rootScope.isIOS = ionic.Platform.isIOS() || ionic.Platform.is('macintel');
      });

      $rootScope.$on("$stateChangeStart", function(
        event,
        toState,
        toParams,
        fromState,
        fromParams
      ) {
        if (toState.data && toState.data.allowAnonymous) {
          return;
        }

        if (toState.data && toState.data.customRestrictionCheck) {
          if($rootScope.techpadSettings && $rootScope.techpadSettings.IsDashboardMode){
            event.preventDefault();
          }
        }

        if (!authService.loggedIn && toState.name !== "login") {
          $rootScope.redirectUrl = $location.url();
          event.preventDefault();
          $state.go("login");
          return;
        }

        if (toState.name !== "login") {
          $rootScope.redirectUrl = "";
        }
      });

      $rootScope.$on("auth:logout", function(event, data) {
        authService.logout();
      });

      document.addEventListener("online", function() {
        eventsMgr.send("device:online");
      });

      document.addEventListener("resume", function() {
        eventsMgr.send("device:resume");
      });

      angular.element(document).on(
        "click",
        _.debounce(function(e) {
          $rootScope.$broadcast("documentClicked", e);
        }, 300)
      );

      $rootScope.safeApply = function(fn) {
        let phase = this.$root && this.$root.$$phase;
        if (phase === "$apply" || phase === "$digest") {
          if (fn && typeof fn === "function") {
            fn();
          }
        } else {
          this.$apply && this.$apply(fn);
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/config.js